export const DISABLE_WIDGETS = ['json'];
